module.exports = __webpack_public_path__ + "static/img/photo1.2afcdcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactUs/photo1.png
// module id = bSVG
// module chunks = 0